import React, { useEffect, useRef, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import makeStyles from '@mui/styles/makeStyles';
import Divider from '@mui/material/Divider';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';


const useStyles = makeStyles((theme) => ({
  alertWrap: {
    minHeight: 65
  },
  heading: {
    fontSize: 16,
    margin: theme.spacing(0, 1),
    fontFamily: theme.fonts.openSans
  },
  accordion: {
    marginTop: theme.spacing(1.2),
    boxShadow: '0px 3px 6px #00000029',
    border: 'none'
  },
  accordionBody: {
    position: 'static'
  },
  icon: {
    color: '#AAAAAA'
  },
  accordionDetails: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column'
  }
}));


const AlertTable = ({ title, alerts, colDefs }) => {
  const classes = useStyles();

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography
          style={{marginRight: "20px"}}
          className={classes.heading}
        >
          {title}
        </Typography>
        <Badge
          style={{marginTop: "15px"}}
          badgeContent={alerts.length}
          color="primary"
          showZero
        >
        </Badge>
      </AccordionSummary>
      <AccordionDetails>
        <div className="ag-theme-quartz" style={{ height: 650, width: 'calc(1030px)' }}>
          <AgGridReact
            rowData={alerts}
            columnDefs={colDefs}
          />
        </div>
      </AccordionDetails>
    </Accordion>
  )
};

export default AlertTable;